import React from "react";
import {
  Table,
  Message,
  Menu,
  Icon,
  Dimmer,
  Loader,
  Dropdown,
  Header,
  Divider,
  Grid,
  Segment
} from "semantic-ui-react";
import { Link } from "react-router-dom";
import _ from "underscore";
import Moment from "moment";
import l from "lodash";

const SysadminUserAuditTable = props => {
  const paginationInfo = `${props.perPage * props.currentPage -
    props.perPage +
    1}-${
    props.perPage * props.currentPage > props.totalData
      ? props.totalData
      : props.perPage * props.currentPage
  } of ${props.totalData}`; 
 
  return (
    <Dimmer.Dimmable>
      <Dimmer active={props.isLoading} inverted>
        <Loader />
      </Dimmer>
      <Segment style={{ top: -10, overflowY:'scroll' }}>
        <Grid container columns={1}>
          <Grid.Column width={16}>
            <Divider horizontal style={{ margin: "13px 0 0 0" }}>
              {" "}
              <Header as="h3">Audit</Header>
            </Divider>
          </Grid.Column>
          <Grid.Column>
            <Table celled selectable>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>New Value</Table.HeaderCell>
                  <Table.HeaderCell>Old Value</Table.HeaderCell>
                  <Table.HeaderCell>Updated Date</Table.HeaderCell>
                  <Table.HeaderCell>Updated By</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {props.result && props.result.length === 0 ? (
                  <Table.Row>
                    <Table.Cell colSpan={6} textAlign="center">
                      <Message info>No user data.</Message>
                    </Table.Cell>
                  </Table.Row>
                ) : (
                  _.map(props.result, (res, i) => {
                    let oldVal = [];
                    oldVal = Object.keys(res).map((k, i) => { 
                      if(k !== 'groupToken'){
                        if(k === 'bankDetail'){
                          return (
                            <div key={i}>
                              {res[k].bankNo && Object.keys(res[k].bankNo).length ? <div>{`Bank No : ${res[k].bankNo.old || ""}`}</div> : ""}
                              {res[k].bankName && Object.keys(res[k].bankName).length ? <div>{`Bank Name : ${res[k].bankName.old || ""}`}</div> : ""}
                              {res[k].branchNo && Object.keys(res[k].branchNo).length ? <div>{`Bank Branch Number : ${res[k].branchNo.old || ""}`}</div> : ""}
                              {res[k].accountNo && Object.keys(res[k].accountNo).length ? <div>{`Bank Account Number : ${res[k].accountNo.old || ""}`}</div> : ""}
                            </div>
                          )
                        }else if (k!=='updated' && k!=='updatedBy'){
                          let val = res[k].old  
                          if (typeof val !== "object") {
                            if (val) {
                              return (
                                <div key={i}>
                                  {k} : {val}
                                </div>
                              );
                            }
                          }else {
                            let keys = Object.keys(res[k]);
                            if (keys.length > 0) {
                              if (
                                !l.isEmpty(res[k].old) &&
                                l.isEmpty(res[k].new)
                              ) {
                                let val, label;
                                if (k === "companies") {
                                  val = res[k].old.map(val => {
                                    return val.companyId.name;
                                  });
                                  label = "company";
                                } else if (k === "family") {
                                  val = res[k].old.map(val => {
                                    return val.name;
                                  });
                                  label = "Dependant";
                                }

                                return (
                                  <div key={i}>{`Removed ${label} : ${val.join(
                                    ","
                                  )}`}</div>
                                );
                              }
                            }
                          }
                        }
                      }
                    });

                    let newVal = Object.keys(res).map((k, i) => {
                      if(k !== 'groupToken'){
                        if(k === 'bankDetail'){
                          return (
                            <div key={i}>
                              {res[k].bankNo && Object.keys(res[k].bankNo).length ? <div>{`Bank No : ${res[k].bankNo.new || ""}`}</div> : ""}
                              {res[k].bankName && Object.keys(res[k].bankName).length ? <div>{`Bank Name : ${res[k].bankName.new || ""}`}</div> : ""}
                              {res[k].branchNo && Object.keys(res[k].branchNo).length ? <div>{`Bank Branch Number : ${res[k].branchNo.new || ""}`}</div> : ""}
                              {res[k].accountNo && Object.keys(res[k].accountNo).length ? <div>{`Bank Account Number : ${res[k].accountNo.new || ""}`}</div> : ""}
                            </div>
                          )
                        } else if (k!=='updated' && k!=='updatedBy'){
                          let val = res[k].new;
                          if (typeof val !== "object") {
                            if (val) {
                              return (
                                <div key={i}>
                                  {k} : {val}
                                </div>
                              );
                            }
                          } else {
                            let keys = Object.keys(res[k]);
                            if (keys.length > 0) {
                              if (
                                l.isEmpty(res[k].old) &&
                                !l.isEmpty(res[k].new)
                              ) {
                                let val, label;
                                if (k === "companies") {
                                  val = res[k].new.map(val => {
                                    return val.companyId.name;
                                  });
                                  label = "company";
                                } else if (k === "family") {
                                  val = res[k].new.map(val => {
                                    return val.name;
                                  });
                                  label = "Dependant";
                                }

                                return (
                                  <div key={i}>{`Added ${label} : ${val.join(
                                    ","
                                  )}`}</div>
                                );
                              }
                            }
                          }
                        }
                      }
                    });

                    return (
                      <Table.Row key={i}>
                        <Table.Cell verticalAlign="top">{oldVal}</Table.Cell>
                        <Table.Cell verticalAlign="top">{newVal}</Table.Cell> 
                        <Table.Cell>
                          {res.updated 
                            ? Moment(res.updated)
                                .format("DD/MM/YYYY, h:mm:ss a")
                                .toUpperCase()
                            : null}
                        </Table.Cell>
                        <Table.Cell>
                          {res.updatedBy  ? res.updatedBy.name : null}
                        </Table.Cell>
                      </Table.Row>
                    );
                  })
                )}
              </Table.Body>
              <Table.Footer>
                <Table.Row>
                  <Table.HeaderCell colSpan="6">
                    <Menu floated="right" pagination>
                      <Menu.Item
                        as="a"
                        icon
                        onClick={props.goToPreviousPage}
                        disabled={props.currentPage === 1}
                      >
                        <Icon name="chevron left" />
                      </Menu.Item>
                      <Menu.Item>{paginationInfo}</Menu.Item>
                      <Menu.Item
                        as="a"
                        icon
                        onClick={props.goToNextPage}
                        disabled={
                          props.currentPage < props.totalPage ? false : true
                        }
                      >
                        <Icon name="chevron right" />
                      </Menu.Item>
                    </Menu>
                    <Menu floated="right" pagination>
                      <Menu.Item>Page</Menu.Item>
                      <Dropdown
                        scrolling
                        item
                        text={props.currentPage.toString()}
                        defaultValue={props.currentPage}
                      >
                        <Dropdown.Menu>
                          {[...Array(props.totalPage)].map((e, i) => (
                            <Dropdown.Item
                              key={i}
                              onClick={() => props.setPage(i + 1)}
                            >
                              {i + 1}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </Menu>
                    <Menu floated="right" pagination>
                      <Menu.Item>View</Menu.Item>
                      <Dropdown
                        item
                        text={props.perPage.toString()}
                        defaultValue={props.perPage}
                      >
                        <Dropdown.Menu>
                          <Dropdown.Item onClick={() => props.setPerPage(10)}>
                            10
                          </Dropdown.Item>
                          <Dropdown.Item onClick={() => props.setPerPage(20)}>
                            20
                          </Dropdown.Item>
                          <Dropdown.Item onClick={() => props.setPerPage(50)}>
                            50
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </Menu>
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Footer>
            </Table>
          </Grid.Column>
        </Grid>
      </Segment>
    </Dimmer.Dimmable>
  );
};

export default SysadminUserAuditTable;
